import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './FaqSection.css'; // You’ll create this file next
import 'bootstrap-icons/font/bootstrap-icons.css';


function FaqSection() {
  return (
    <div className="w-100 px-3 px-md-5 py-5 bg-black text-white">
      <h2 className="text-center mb-5 display-4 fw-bold text-primary">
        Frequently Asked Questions
      </h2>

      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12">
          <div className="accordion" id="faqAccordion">

            {/* FAQ Item 1 */}
            <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed bg-dark text-white fw-semibold fs-5"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq1"
                >
                  <i className="bi bi-question-circle me-3 text-primary fs-4"></i>
                  What is MortBuzz Home Loan Agents In Hadapsar Pune and how can I apply for a loan?
                </button>
              </h2>
              <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                <div className="accordion-body text-light border-start border-primary ps-4">
                  MortBuzz offers convenient home loans from top banks. Apply online at{' '}
                  <a href="https://mortbuzz.in" className="text-primary text-decoration-none">mortbuzz.in</a>. We handle everything—no bank visit needed.
                </div>
              </div>
            </div>

            {/* FAQ Item 2 */}
            <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed bg-dark text-white fw-semibold fs-5"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq2"
                >
                  <i className="bi bi-percent me-3 text-primary fs-4"></i>
                  What is the interest rate on the home loan?
                </button>
              </h2>
              <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                <div className="accordion-body text-light border-start border-primary ps-4">
                  The current interest rate is <strong className="text-success">8.10%</strong>. One of the most competitive in the market.{' '}
                  <a href="#" className="text-primary text-decoration-none">Check your eligibility</a> now.
                </div>
              </div>
            </div>

            {/* FAQ Item 3 */}
            <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed bg-dark text-white fw-semibold fs-5"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq3"
                >
                  <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
                  How does the cashback offer work?
                </button>
              </h2>
              <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                <div className="accordion-body text-light border-start border-primary ps-4">
                  Cashback depends on your loan amount:
                  <ul className="mt-2">
                    <li><strong>Above ₹1 Cr:</strong> 100% cashback on fees.</li>
                    <li><strong>₹90 Lakh:</strong> 90% cashback.</li>
                    <li><strong>₹20 Lakh:</strong> 20% cashback.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* FAQ Item 4 */}
            <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed bg-dark text-white fw-semibold fs-5"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faq4"
                >
                  <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
                  What is the process for obtaining a home loan from MortBuzz?
                </button>
              </h2>
              <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                <div className="accordion-body text-light border-start border-primary ps-4">
                  <ol>
                    <li>Apply at <a href="https://mortbuzz.in" className="text-primary">mortbuzz.in</a>.</li>
                    <li>Our team will collect your documents.</li>
                    <li>We handle approval with banks.</li>
                    <li>Door-to-door service with no bank visits.</li>
                    <li>Enjoy cashback and fast approval.</li>
                  </ol>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
